import { http } from "../infrastructure/Https";
import tokenService from "../services/TokenService";
import {
  BodyParamsPostFile,
  PartnerLeadsResType,
  documentType,
  partnerApplicationsListQuery,
} from "../types/partnerApiTypes";

const ROOT_URL = "/api/v1/partner";

export type ReferencePartnerInfo = {
  partner: string;
  lead_id: string;
  payout: number;
};

class PartnerApi {
  //OLD POST ​/api​/v1​/partner​/lead​/filev2 Запросить файл и опционально подпись файла
  postLeadFile(data: documentType, leadId: any): Promise<string> {
    const accessToken = tokenService.getAccessToken();
    const formData = new FormData();
    formData.append("leadid", leadId);
    formData.append("fileName", data.fileName);
    formData.append("Comment", data.Comment);
    formData.append("isSignatureRequired", String(data.isSignatureRequired));
    // if (data.doc) formData.append("File", data.doc);
    return http.post(
      `${ROOT_URL}/lead/filev2`,
      undefined,
      formData,
      accessToken
    );
  }

  //POST ​/api​/v1​/partner​/lead​/multi/file Запросить документ и опционально подпись файла
  postAskDoc(
    B: BodyParamsPostFile
  ): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    return http.post(
      `${ROOT_URL}/lead/multi/file`,
      undefined,
      B,
      accessToken
    );
  }

  //POST /api/v1/partner/lead/file_example/multi Прикрепить образец документа
  postDocTemplate(
    leadId: number,
    formData: FormData,
    onProgress: (percentage: number, loadedMB: string, totalMB: string) => void,
    signal: AbortSignal
  ) {
    return new Promise((resolve, reject) => {
      const url = `${ROOT_URL}/lead/file_example/multi`
      const xhr = new XMLHttpRequest();
      const accessToken = tokenService.getAccessToken();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentage = (event.loaded / event.total) * 100;
          const loadedMB = (event.loaded / 1024 / 1024).toFixed(2);
          const totalMB = (event.total / 1024 / 1024).toFixed(2);
          onProgress(percentage, loadedMB, totalMB);
        }
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(`Upload failed: ${xhr.status} ${xhr.statusText}`);
        }
      };
      xhr.onerror = () => {
        reject('Network error occurred during the upload process');
      };
      // listen for the abort event
      signal.addEventListener('abort', () => {
        xhr.abort();
        reject(new Error('прервано'));
      });
      xhr.send(formData);
    });
  };

  //DELETE ​/api​/v1/​partner/lead/file_example/multi Удалить пример документа by doc id
  deleteDocExample(documentId: number): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    const requestBody = { documentId };
    return http.delete(
      `${ROOT_URL}/lead/file_example/multi`,
      null,
      requestBody,
      accessToken
    );
  }

  // OLD POST ​/api​/v1​/partner​/lead​/file_example  Прикрепить/очистить пример документа на запрошенный документ
  attachFileExample(
    baseDocumentId: number,
    clear: boolean,
    data: documentType
  ): Promise<string> {
    const accessToken = tokenService.getAccessToken();
    const formData = new FormData();
    formData.append("baseDocumentId", baseDocumentId.toString());
    formData.append("clear", clear.toString());
    formData.append("documentFile", data.doc);
    return http.post(
      `${ROOT_URL}/lead/file_example`,
      undefined,
      formData,
      accessToken
    );
  }

  //PUT ​/api​/v1​/partner​/lead​/{leadid}​/archive Архивирование заявки
  putLeadArchive(leadid: number): Promise<string> {
    const accessToken = tokenService.getAccessToken();
    return http.put(
      `${ROOT_URL}/lead/${leadid}/archive`,
      undefined,
      undefined,
      accessToken
    );
  }

  //PUT ​/api​/v1​/partner​/lead​/status Изменение статуса заявки
  changeLeadStatus(leadid: number, newStatus: string): Promise<any> {
    const data = { leadid, newstatus: newStatus };
    const accessToken = tokenService.getAccessToken();
    return http.put(`${ROOT_URL}/lead/status`, undefined, data, accessToken);
  }

  //GET ​/api​/v1​/partner​/lead Получение заявок банка
  getLeads(Q: partnerApplicationsListQuery): Promise<PartnerLeadsResType> {
    const accessToken = tokenService.getAccessToken();
    return http.get(`${ROOT_URL}/lead`, Q, accessToken);
  }

  //PUT​/api​/v1​/partner​/lead​/{leadid}​/read Снятие флага новый с заявки
  takeOffLeadFlagNew(leadid: number): Promise<string> {
    const accessToken = tokenService.getAccessToken();
    return http.put(
      `${ROOT_URL}/lead/${leadid}/read`,
      undefined,
      undefined,
      accessToken
    );
  }

  //POST/api​/v1​/user/c2mcallback/{cid} Отправка click id.
  sendClickId(cid: string): Promise<void> {
    return http.post(`/api/v1/user/c2mcallback/${cid}`);
  }
}

const partnerApi = new PartnerApi();
export default partnerApi;
